<script setup lang="ts">
  import { textButtonGroupProps } from './text-button';
  import ITextButton from './text-button.vue';
  defineOptions({
    name: 'ITextButtonGroup',
  });
  defineProps(textButtonGroupProps);
</script>

<template>
  <div class="i-text-button-group">
    <template v-for="(button, index) of group" :key="`${index}${button?.text}`">
      <slot v-if="button.slot" :name="button.slot" />
      <ITextButton v-else :icon="button.icon" :text-color="button.textColor" :disabled="button.disabled">
        {{ button?.text }}
      </ITextButton>
    </template>
  </div>
</template>
